<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("Manual Billing Categories", 2) }}
        </div>
        <div class="section-subTitle my-2">
          {{ "List Of All Manual Billing Categories" }}
        </div>
      </div>
      <div v-if="$can('create', 'Manual Bill Categories')">
        <b-button
          variant="default"
          to="add-billing-categories"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:800="getManualBillingCategories"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            variant="dropdown-curve"
            class="ml-auto mr-3 filter-dropdown"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status)"
              >{{ status.status }}</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'category_name'"
              @click="onSortValue('category_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('category_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('category_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("Category", 1) }}
          </th>
        </tr>
      </thead>
      <template v-if="Categories && Categories.length > 0">
        <tbody>
          <tr v-for="(item, key) in Categories" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    item.category_is_active === 'Y' ? 'active' : 'inactive'
                  "
                />

                <!-- Icon with tooltip and click event -->
                <span
                  class="edit-pen ml-4 blue-icon"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                  v-if="$can('update', 'Manual Bill Categories')"
                  @click="
                    goToRoute('/cinema-manager/edit-billing-categories', item)
                  "
                ></span>
              </div>
            </td>

            <td>{{ $tc(item.category_name, 1) }}</td>
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    item.category_is_active == 'Y' ? 'active' : 'inactive'
                  "
                />

                <b-dropdown
                  right
                  variant="edit"
                  class="ml-4"
                  v-if="$can('update', 'Manual Bill Categories')"
                >
                  <b-dropdown-item
                    @click="
                      goToRoute('/cinema-manager/edit-billing-categories', item)
                    "
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
          </tr>
        </tbody>
      </template>

      <tbody v-if="Categories.length == 0">
        <tr>
          <td colspan="3">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Categories.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      filter_is_active: "Y",
      Categories: [],
      perPage: 10,
      isEditable: false,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active", flag: "Y" },
        { status: "Inactive", flag: "N" },
        { status: "All", flag: null },
      ],
      gridView: false,
      listView: true,
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  beforeMount() {
    this.getManualBillingCategories();
    this.getviewingnumber();
  },
  methods: {
    filterStatus: function (status) {
      this.filterButtonTitle = status.status;
      this.filter_is_active = status.flag;
      this.getManualBillingCategories();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getManualBillingCategories();
      } else {
        this.currentPage = event;
        this.getManualBillingCategories();
      }
    },
    goToRoute: function (path, item) {
      const { category_id } = item;
      this.$router.push({
        path: path,
        query: {
          category_id: category_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getManualBillingCategories();
    },
    getManualBillingCategories: function () {
      this.Categories = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        filter_is_active: this.filter_is_active,
      };
      MasterService.GetAllManualBiilingCategory(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Categories = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ManualBillingComponents/listManualBillingCategories.vue